'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('external.change-password', {
        views: {
            'externalContent': {
                component: 'changePassword',
            }
        }
    })
}


// WEBPACK FOOTER //
// ./client/app/features/change-password/change-password.routes.js